import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { RotateCcw } from "lucide-react";

// Page-level "Reset all filters": shows only when one or more deep-link
// query parameters are active, and returns the page to its default view.
export const ResetFiltersButton = ({ ignore = [] }) => {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = [...sp.keys()].filter((k) => !ignore.includes(k));
  if (active.length === 0) return null;
  return (
    <div className="mb-3 flex justify-end">
      <button
        data-testid="reset-all-filters"
        onClick={() => navigate(pathname)}
        aria-label="Reset all filters and return to the default view"
        className="inline-flex items-center gap-1.5 rounded-full border border-[#E4E9F3] bg-white px-3 py-1.5 text-xs font-semibold text-[#5A6B8C] transition-colors hover:border-[#1D4ED8] hover:text-[#1D4ED8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1D4ED8]/40"
      >
        <RotateCcw size={13} /> Reset all filters
      </button>
    </div>
  );
};
